module.exports = __webpack_public_path__ + "img/hic-pneumonia-female.e63a50db.png";